import { metrics } from '@atlassian/browser-metrics';
import type { Metric } from '@atlassian/browser-metrics/types';

export const interactionMetrics: {
	initializeChannels: Metric;
	timeToRenderMessageContent: Metric;
	timeToRenderFinalResponse: Metric;
	sendConfirmedToolsTimeToFinishStream: Metric;
	sendConfirmedToolsTimeToFirstAnswerPart: Metric;
	messageCompositionTime: Metric;
} = {
	initializeChannels: metrics.interaction({
		key: 'ai-mate.initialize-channels',
	}),
	timeToRenderMessageContent: metrics.interaction({
		key: 'ai-mate.time-to-render-message-content',
	}),
	timeToRenderFinalResponse: metrics.interaction({
		key: 'ai-mate.time-to-render-final-response',
	}),
	sendConfirmedToolsTimeToFinishStream: metrics.interaction({
		key: 'ai-mate.send-confirmed-tools.time-to-finish-stream',
	}),
	sendConfirmedToolsTimeToFirstAnswerPart: metrics.interaction({
		key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part',
	}),
	messageCompositionTime: metrics.interaction({
		key: 'ai-mate.message-composition-time',
	}),
} satisfies Record<string, Metric>;
